import axios from "axios";

const API_URL = process.env.REACT_APP_API_SERVICE;

export const getCandidateStatsAndHistory = async (userId) => {
    try {
        const res = await axios.get(`${API_URL}/users/history/${userId}`,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            });
        return res;
    } catch (error) {
        return error;
    }
}